<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container hr-dashboard">
      <div
        class="page-heading d-flex justify-content-between align-items-center"
      >
        <div class="main-head">
          <span>HR Portal Dashboard</span>
        </div>
      </div>
      <div class="d-flex mt-3">
        <div style="width: 50%">
          <div class="d-flex">
            <div
              class="shortlisted-hr-dash-cand-container pointer"
              @click="gotoslectedcandpage"
            >
              <div
                class="d-flex justify-content-between align-items-center p-3"
              >
                <div class="hr-dash-cand-maintext">
                  {{ shortlisted }}
                  <div class="hr-dash-cand-subtext mt-3">
                    Shortlisted Candidates
                  </div>
                </div>
                <div>
                  <img src="../../assets/img/hrportal/scsvg.svg" alt="" />
                </div>
              </div>
            </div>
            <div
              class="ml-2 onbaord-hr-dash-cand-container pointer"
              @click="gotoonboardingpage"
            >
              <div
                class="d-flex justify-content-between align-items-center p-3"
              >
                <div class="hr-dash-cand-maintext">
                  {{ accepted }}
                  <div class="hr-dash-cand-subtext mt-3">Offer Accepted</div>
                </div>
                <div>
                  <img src="../../assets/img/hrportal/ocsvg.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex mt-2">
            <div
              class="rejected-hr-dash-cand-container pointer"
              @click="gotorejectedPage"
            >
              <div
                class="d-flex justify-content-between align-items-center p-3"
              >
                <div class="hr-dash-cand-maintext">
                  {{ rejected }}
                  <div class="hr-dash-cand-subtext mt-3">Offer Rejected</div>
                </div>
                <div>
                  <img src="../../assets/img/hrportal/rcsvg.svg" alt="" />
                </div>
              </div>
            </div>
            <div
              class="ml-2 send-hr-dash-cand-container pointer"
              @click="goToAppoint"
            >
              <div
                class="d-flex justify-content-between align-items-center p-3"
              >
                <div class="hr-dash-cand-maintext">
                  {{ appointed }}
                  <div class="hr-dash-cand-subtext mt-3">Send Appointment</div>
                </div>
                <div>
                  <img src="../../assets/img/hrportal/sasvg.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hr-dash-notifn-container ml-2" style="width: 50%">
          <div class="hr-notification-text p-2">
            <img
              src="../../assets/img/hrportal/bellicon.svg"
              class="mr-1"
              alt=""
            />
            Notifications
          </div>
          <div class="d-flex justify-content-between p-2">
            <div class="hr-notification-innercards d-flex align-items-center">
              <div class="noti-icon-bg">
                <img src="../../assets/img/hrportal/flag.svg" alt="" />
              </div>
              <div class="hr-notification-subtext ml-2">
                {{ notificationsObject.numberOfShortlistedCandidates }} New
                shortlisted candiates are added today
              </div>
            </div>
            <div
              class="hr-notification-innercards d-flex align-items-center ml-2"
            >
              <div class="noti-icon-bg">
                <img src="../../assets/img/hrportal/appdops.svg" alt="" />
              </div>
              <div class="hr-notification-subtext ml-2">
                Check Candidates approved by OpsHead
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between p-2">
            <div class="hr-notification-innercards d-flex align-items-center">
              <div class="noti-icon-bg">
                <img src="../../assets/img/hrportal/file.svg" alt="" />
              </div>
              <div class="hr-notification-subtext ml-2">
                Review onboarding documents send by candidate
              </div>
            </div>
            <div
              class="hr-notification-innercards d-flex align-items-center ml-2"
            >
              <div class="noti-icon-bg">
                <img src="../../assets/img/hrportal/rejdops.svg" alt="" />
              </div>
              <div class="hr-notification-subtext ml-2">
                Check Candidates rejected by OpsHead
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between p-2">
            <div class="hr-notification-innercards d-flex align-items-center">
              <div class="noti-icon-bg">
                <img
                  src="../../assets/img/hrportal/completedonboard.svg"
                  alt=""
                />
              </div>
              <div class="hr-notification-subtext ml-2">
                Today,
                {{ notificationsObject.numberOfOnboardedCandidates }} candidates
                completed their onboarding
              </div>
            </div>
            <div
              class="hr-notification-innercards d-flex align-items-center ml-2"
            >
              <div class="noti-icon-bg">
                <img src="../../assets/img/hrportal/rejdoffer.svg" alt="" />
              </div>
              <div class="hr-notification-subtext ml-2">
                {{ notificationsObject.numberOfCandidatesRejected }} candidates
                are rejected their offer
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hr-dashboard-table-container relativeclass mt-3">
        <div class="hr-notification-text">Recent Activity</div>
        <div class="tabbed panellogintabs">
          <div class="d-flex align-items-center justify-content-between">
            <div class="search-bar mr-3 mt-2">
              <img
                class="searchicon"
                src="../../assets/img/search-bar-icon.svg"
                alt=""
              />

              <b-form-input
                type="search"
                class="search-input"
                placeholder="Search candidate"
                v-model.trim="searchQuery"
                @keyup="textSearch()"
              ></b-form-input>
            </div>
            <div></div>
          </div>
          <b-tabs v-model="tabIndex" class="mt-3">
            <b-tab
              title="Show All"
              @click="
                getCandidates((actionList = ''), (page = 1), (goToPage = null))
              "
            >
              <!-- table starts -->
              <div class="table-main">
                <table
                  class="w-100 table-design hr-dashboard-table"
                  :aria-describedby="'All'"
                >
                  <thead>
                    <tr class="selected-table-cards">
                      <th style="width: 15%">
                        <span class="pl-4"> Candidate Name </span>
                        <template v-if="statusValue == 'customerName'">
                          <img
                            v-if="!sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'customerName'),
                                (order = 1);
                              getCandidates();
                            "
                            src="../../assets/img/candidatedashboard/upfilter.svg"
                            alt=""
                          />
                          <img
                            v-if="sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'customerName'),
                                (order = -1);
                              getCandidates();
                            "
                            src="../../assets/img/candidatedashboard/downfilter.svg"
                            alt=""
                          />
                        </template>
                        <img
                          class="pointer"
                          v-else
                          @click="
                            (filter = true),
                              (statusValue = 'customerName'),
                              (sortByValue = true),
                              (order = 1),
                              getCandidates()
                          "
                          src="../../assets/img/candidatedashboard/nofilter.svg"
                          alt=""
                        />
                      </th>
                      <th style="width: 10%" class="text-center">
                        Email
                        <template v-if="statusValue == 'email'">
                          <img
                            v-if="!sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'email'),
                                (order = 1),
                                getCandidates()
                            "
                            src="../../assets/img/candidatedashboard/upfilter.svg"
                            alt=""
                          />
                          <img
                            v-if="sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'email'),
                                (order = -1),
                                getCandidates()
                            "
                            src="../../assets/img/candidatedashboard/downfilter.svg"
                            alt=""
                          />
                        </template>
                        <img
                          class="pointer"
                          v-else
                          @click="
                            (filter = true),
                              (statusValue = 'email'),
                              (sortByValue = true),
                              (order = 1),
                              getCandidates()
                          "
                          src="../../assets/img/candidatedashboard/nofilter.svg"
                          alt=""
                        />
                      </th>
                      <th style="width: 10%" class="text-center">
                        Date of joining
                      </th>
                      <th style="width: 10%" class="text-center">Department</th>
                      <th style="width: 10%" class="text-center">
                        Candidate CTC
                      </th>
                      <th style="width: 20%" class="text-center">
                        Current status
                      </th>
                      <th style="width: 20%" class="text-center">Actions</th>
                      <th style="width: 5%"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(i, index) in allcandidate"
                      :key="index"
                      class="selected-table-cards"
                    >
                      <td style="width: 15%">
                        <div
                          :style="{
                            background:
                              '#' + Math.random().toString(16).slice(-6),
                          }"
                          class="gridgreencolorDynamic mr-1"
                        ></div>
                        <span class="pl-4">
                          {{ `${i.firstName} ${i.middleName} ${i.lastName}` }}
                        </span>
                      </td>
                      <td
                        style="width: 10%"
                        class="text-center text-truncate"
                        v-b-tooltip.hover.bottom="i.email"
                      >
                        {{ i.email }}
                      </td>
                      <td style="width: 10%" class="text-center">
                        {{ i.dateOfJoining.slice(0, 10) | formatdate }}
                      </td>
                      <td style="width: 10%" class="text-center">
                        {{ i.department }}
                      </td>
                      <td style="width: 10%" class="text-center">
                        {{ i.offeredCTC }}
                      </td>
                      <td
                        style="width: 20%"
                        class="text-center text-truncate"
                        v-b-tooltip.hover.bottom="i.statusDescription"
                      >
                        {{ i.statusDescription }}
                      </td>
                      <td style="width: 20%" class="text-center">
                        <b-button
                          style="width: 80%"
                          @click="openDocsModel(i), getDocuments()"
                          v-if="i.status == 4"
                          class="addbtn"
                        >
                          Send Onboarding Docs
                        </b-button>
                        <b-button
                          style="width: 80%"
                          @click="
                            goToReviewDocs(i.RecCandidateID), getDocuments()
                          "
                          v-else-if="i.status == 7"
                          class="addbtn"
                        >
                          Review Onboarding docs
                        </b-button>
                        <b-button
                          style="width: 80%"
                          v-else-if="i.status == 8"
                          class="addbtn"
                          @click="
                            (selectedCandidate = i), $bvModal.show('onboard')
                          "
                        >
                          Onboard Candidate
                        </b-button>
                        <b-button
                          style="width: 80%"
                          v-else-if="i.status == 1 || i.status == 11"
                          class="addbtn"
                          @click="goToResend(i.RecCandidateID)"
                        >
                          Resend Offer Letter
                        </b-button>
                        <b-button
                          style="width: 80%"
                          v-else-if="i.status == 10"
                          class="addbtn"
                          @click="goToGenerateOffer(i.RecCandidateID)"
                        >
                          Regenerate Offer Letter
                        </b-button>
                        <b-button
                          v-else-if="i.status == 6"
                          class="addbtn"
                          @click="getAssignedDocs(i), getDocuments()"
                          style="width: 80%"
                        >
                          Resend Onboarding Docs
                        </b-button>
                      </td>
                      <td style="width: 5%" class="text-right">
                        <div class="d-flex align-items-center">
                          <div
                            class="p-2 mr-1"
                            @click="goToCandidateDetails(i.RecCandidateID)"
                          >
                            <img
                              v-b-popover.hover.top="'View'"
                              src="../../assets/eyeicon.svg"
                              class="pointer"
                              alt=""
                            />
                          </div>
                          <div v-if="i.status != 10" class="viewmore-parent">
                            <div class="pointer" :id="i.RecCandidateID">
                              <img
                                src="../../assets/img/hrportal/viewmore.svg"
                                alt=""
                              />
                            </div>
                            <b-popover
                              :target="i.RecCandidateID"
                              triggers="hover"
                              placement="bottomleft"
                            >
                              <div
                                @click="openNotInterested(i)"
                                class="hr-nibox pointer"
                              >
                                Not Interested
                              </div>
                            </b-popover>
                          </div>
                          <div v-if="i.status == 10" class="viewmore-parent">
                            <div class="pointer">
                              <img
                                class="disable-viewmore"
                                src="../../assets/img/hrportal/viewmoredisabled.svg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="allcandidate.length === 0">
                      <td class="text-center">No Records Found</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- table ends -->
              <div
                class="
                  paginaTion
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <span class="qb-gotopage-text p-1">Go to page</span>
                  <b-form-input
                    type="text"
                    class="qb-pagination-num mr-1"
                    v-model="goToPage"
                    @keyup.enter="
                      goToPage === null || goToPage == '' || iscontainsNumber
                        ? ''
                        : gotopgnum(goToPage)
                    "
                  ></b-form-input>
                  <b-button
                    class="qb-pagination-addbtn"
                    @click="gotopgnum(goToPage)"
                    :disabled="
                      goToPage === null || goToPage == '' || iscontainsNumber
                    "
                  >
                    <span
                      ><img src="../../assets/whiterightarrow.svg" alt=""
                    /></span>
                  </b-button>
                </div>
                <div class="pagination">
                  <b-pagination
                    v-model="page"
                    @input="getCandidates()"
                    :total-rows="total"
                    :per-page="count"
                    align="center"
                    first-number
                    last-number
                  >
                    <template #prev-text
                      ><span
                        ><img src="../../assets/leftvector.svg" alt="" /> </span
                    ></template>
                    <template #next-text
                      ><span
                        ><img src="../../assets/rightarrow.svg" alt="" /></span
                    ></template>
                  </b-pagination>
                </div>
                <div class="qb-gotopage-text mr-2">
                  Results : <span v-if="pageStart > total">0</span
                  ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                  <span class="pl-1"></span> of <span class="pr-1"></span
                  >{{ total }}
                </div>
              </div>
            </b-tab>
            <b-tab
              title="Action List"
              @click="
                getCandidates((actionList = 'a'), (page = 1), (goToPage = null))
              "
            >
              <!-- table starts -->
              <div class="table-main">
                <table
                  class="w-100 table-design hr-dashboard-table"
                  :aria-describedby="'Actin list'"
                >
                  <thead>
                    <tr>
                      <th style="width: 15%">
                        <span class="pl-4"> Candidate Name </span>
                        <template v-if="statusValue == 'customerName'">
                          <img
                            v-if="!sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'customerName'),
                                (order = 1);
                              getCandidates();
                            "
                            src="../../assets/img/candidatedashboard/upfilter.svg"
                            alt=""
                          />
                          <img
                            v-if="sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'customerName'),
                                (order = -1);
                              getCandidates();
                            "
                            src="../../assets/img/candidatedashboard/downfilter.svg"
                            alt=""
                          />
                        </template>
                        <img
                          class="pointer"
                          v-else
                          @click="
                            (filter = true),
                              (statusValue = 'customerName'),
                              (sortByValue = true),
                              (order = 1),
                              getCandidates()
                          "
                          src="../../assets/img/candidatedashboard/nofilter.svg"
                          alt=""
                        />
                      </th>
                      <th style="width: 10%" class="text-center">
                        <span class="pl-4"> Email </span>
                        <template v-if="statusValue == 'email'">
                          <img
                            v-if="!sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'email'),
                                (order = 1),
                                getCandidates()
                            "
                            src="../../assets/img/candidatedashboard/upfilter.svg"
                            alt=""
                          />
                          <img
                            v-if="sortByValue && filter"
                            class="pointer"
                            @click="
                              (sortByValue = !sortByValue),
                                (statusValue = 'email'),
                                (order = -1),
                                getCandidates()
                            "
                            src="../../assets/img/candidatedashboard/downfilter.svg"
                            alt=""
                          />
                        </template>
                        <img
                          class="pointer"
                          v-else
                          @click="
                            (filter = true),
                              (statusValue = 'email'),
                              (sortByValue = true),
                              (order = 1),
                              getCandidates()
                          "
                          src="../../assets/img/candidatedashboard/nofilter.svg"
                          alt=""
                        />
                      </th>
                      <th style="width: 10%" class="text-center">
                        Date of joining
                      </th>
                      <th style="width: 10%" class="text-center">Department</th>
                      <th style="width: 10%" class="text-center">
                        Candidate CTC
                      </th>
                      <th style="width: 20%" class="text-center">
                        Current status
                      </th>
                      <th style="width: 20%" class="text-center">Action</th>
                      <th style="width: 5%"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="selected-table-cards"
                      v-for="(i, index) in actionCandidates"
                      :key="index"
                    >
                      <td style="width: 15%">
                        <div class="name-cel">
                          <div
                            :style="{
                              background:
                                '#' + Math.random().toString(16).slice(-6),
                            }"
                            class="gridgreencolorDynamic mr-1"
                          ></div>
                          <span class="pl-4">
                            {{ `${i.firstName} ${i.middleName} ${i.lastName}` }}
                          </span>
                        </div>
                      </td>
                      <td
                        style="width: 10%"
                        class="text-center text-truncate"
                        v-b-tooltip.hover.bottom="i.email"
                      >
                        <span>{{ i.email }}</span>
                      </td>
                      <td style="width: 10%" class="text-center">
                        <span>{{
                          i.dateOfJoining.slice(0, 10) | formatdate
                        }}</span>
                      </td>
                      <td style="width: 10%" class="text-center">
                        <span>{{ i.department }}</span>
                      </td>

                      <td style="width: 10%" class="text-center">
                        <span>{{ i.offeredCTC }}</span>
                      </td>
                      <td
                        style="width: 20%"
                        class="text-center text-truncate"
                        v-b-tooltip.hover.bottom="i.statusDescription"
                      >
                        <span> {{ i.statusDescription }}</span>
                      </td>
                      <td style="width: 20%" class="text-center">
                        <b-button
                          style="width: 80%"
                          @click="openDocsModel(i), getDocuments()"
                          v-if="i.status == 4"
                          class="addbtn"
                        >
                          Send Onboarding Docs
                        </b-button>
                        <b-button
                          style="width: 80%"
                          @click="
                            goToReviewDocs(i.RecCandidateID), getDocuments()
                          "
                          v-else-if="i.status == 7"
                          class="addbtn"
                        >
                          Review Onboarding docs
                        </b-button>
                        <b-button
                          style="width: 80%"
                          v-else-if="i.status == 8"
                          class="addbtn"
                          @click="
                            (selectedCandidate = i), $bvModal.show('onboard')
                          "
                        >
                          Onboard Candidate
                        </b-button>
                        <b-button
                          style="width: 80%"
                          v-else-if="i.status == 1 || i.status == 11"
                          class="addbtn"
                          @click="goToResend(i.RecCandidateID)"
                        >
                          Resend Offer Letter
                        </b-button>
                        <b-button
                          style="width: 80%"
                          v-else-if="i.status == 10"
                          class="addbtn"
                          @click="goToGenerateOffer(i.RecCandidateID)"
                        >
                          Regenerate Offer Letter
                        </b-button>
                      </td>
                      <td style="width: 5%" class="text-right">
                        <div class="d-flex align-items-center">
                          <div
                            class="p-2 mr-1"
                            @click="goToCandidateDetails(i.RecCandidateID)"
                          >
                            <img
                              src="../../assets/eyeicon.svg"
                              class="pointer"
                              alt=""
                            />
                          </div>

                          <div v-if="i.status != 10" class="viewmore-parent">
                            <div class="pointer" :id="i.email">
                              <img
                                src="../../assets/img/hrportal/viewmore.svg"
                                alt=""
                              />
                            </div>
                            <b-popover
                              :target="i.email"
                              triggers="hover"
                              placement="bottomleft"
                            >
                              <div
                                @click="openNotInterested(i)"
                                class="hr-nibox pointer"
                              >
                                Not Interested
                              </div>
                            </b-popover>
                          </div>
                          <div v-if="i.status == 10" class="viewmore-parent">
                            <div class="pointer">
                              <img
                                class="disable-viewmore"
                                src="../../assets/img/hrportal/viewmoredisabled.svg"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="actionCandidates.length === 0">
                      <td class="text-center">No Records Found</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- table ends -->
              <div
                class="
                  paginaTion
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <span class="qb-gotopage-text p-1">Go to page</span>
                  <b-form-input
                    type="text"
                    class="qb-pagination-num mr-1"
                    v-model="goToPage"
                    @keyup.enter="
                      goToPage === null || goToPage == '' || iscontainsNumber
                        ? ''
                        : gotopgnum(goToPage)
                    "
                  ></b-form-input>
                  <b-button
                    class="qb-pagination-addbtn"
                    @click="gotopgnum(goToPage)"
                    :disabled="
                      goToPage === null || goToPage == '' || iscontainsNumber
                    "
                  >
                    <span
                      ><img src="../../assets/whiterightarrow.svg" alt=""
                    /></span>
                  </b-button>
                </div>
                <div class="pagination">
                  <b-pagination
                    v-model="page"
                    @input="getCandidates()"
                    :total-rows="total"
                    :per-page="count"
                    align="center"
                    first-number
                    last-number
                  >
                    <template #prev-text
                      ><span
                        ><img src="../../assets/leftvector.svg" alt="" /> </span
                    ></template>
                    <template #next-text
                      ><span
                        ><img src="../../assets/rightarrow.svg" alt="" /></span
                    ></template>
                  </b-pagination>
                </div>
                <div class="qb-gotopage-text mr-2">
                  Results : <span v-if="pageStart > total">0</span
                  ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                  <span class="pl-1"></span> of <span class="pr-1"></span
                  >{{ total }}
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <b-modal
      id="assign-docs"
      size="l"
      centered
      hide-footer
      hide-header
      class="p-0 jddetailsmodal"
      :no-close-on-backdrop="true"
      @hidden="closeAssignDocs"
    >
      <div
        class="page-heading d-flex justify-content-between align-items-center"
      >
        <div class="jd-modal-heading">
          <span>Assign Documents</span>
        </div>
      </div>
      <div @click="closeAssignDocs" class="xMarkCancel">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>

      <hr />

      <div class="doc-modal mt-1 d-flex flex-column justify-content-between">
        <div class="doc-sub">
          <div class="w-100">
            <span class="doc-model-sub-head"> Select Experience Level </span>
            <b-form-radio-group
              class="
                mt-2
                options-text
                modal-radio-feedback
                d-flex
                justify-content-between
                align-items-center
              "
              v-model="isFresher"
            >
              <b-form-radio value="true">Fresher</b-form-radio>
              <b-form-radio value="false" class="mr-5">Experience</b-form-radio>
            </b-form-radio-group>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(0)"
            >
              <div class="heading-doc">Registration Form</div>
              <div>
                <img
                  v-if="!dropDownToggle[0]"
                  src="../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="reg-form-list" v-if="dropDownToggle[0]">
            <b-form-group>
              <b-form-checkbox
                size="sm"
                v-for="(docs, index) in registrationForms"
                :key="index"
                :value="docs.value"
                v-model="selectedRegForm"
                class="qb-dropdown-option-sing options-text"
              >
                {{ docs.name }}
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(1)"
            >
              <div class="heading-doc">Attach Documents</div>
              <div>
                <img
                  v-if="!dropDownToggle[1]"
                  src="../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="reg-form-list" v-if="dropDownToggle[1]">
            <b-form-checkbox
              size="sm"
              v-for="(docs, index) in documentsList"
              :key="index"
              :value="docs"
              v-model="selectedDocs"
              class="qb-dropdown-option-sing options-text"
            >
              {{ docs.text }}
            </b-form-checkbox>
          </div>

          <div class="reg-form mt-3">
            <div
              class="d-flex align-items-center justify-content-between pointer"
              @click="toggleDropDown(2)"
            >
              <div class="heading-doc">Declaration Documents</div>
              <div>
                <img
                  v-if="!dropDownToggle[2]"
                  src="../../assets/img/hrportal/listdownicon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/img/hrportal/listupicon.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="dec-form-list" v-if="dropDownToggle[2]">
            <b-form-group>
              <b-form-checkbox
                size="sm"
                v-for="(docs, index) in documentDetails"
                :key="index"
                :value="{
                  name: docs.documentName,
                  value: docs.documentID,
                }"
                v-model="selectedDecDocs"
                class="qb-dropdown-option-sing options-text"
              >
                {{ docs.documentName }}
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="heading-doc mt-3">Select Expiry Date</div>

          <div class="topDiv datepicker-cust mt-3">
            <label class="datefieldsetStyle"
              >Expiry Date&nbsp;<span class="asterik">*</span></label
            >
            <b-form-datepicker
              id="example-datepicker3"
              class="joiningstyle"
              ref="dob"
              v-model="$v.expiryDate.$model"
              :class="{ error: $v.expiryDate.$error }"
            ></b-form-datepicker>
            <div
              class="validationicon-exp"
              v-if="$v.expiryDate.$dirty && !$v.expiryDate.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
            <img
              @click="gotoexpdate"
              class="calender-class pointer"
              src="../../assets/calenderIcon.svg"
              alt=""
            />
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <b-button
            class="addbtn confirm-btn"
            @click="reassign == true ? putDocs() : postDocs()"
          >
            Confirm & Send
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="not-interested"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
      :no-close-on-backdrop="true"
      @hidden="$bvModal.hide('not-interested')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
        style="color: #545454"
      >
        Confirmation
      </div>
      <hr />
      <div @click="$bvModal.hide('not-interested')" class="xMarkCancel">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <div>
        <div class="modal-text">
          Do you want to move
          <span class="options-text"
            >&ldquo;{{ selectedCandidate.email }}&ldquo;</span
          >
          to uninterested?
        </div>
        <div class="topDiv mt-4">
          <label class="fieldsetStyle">Remarks</label>
          <b-form-textarea
            class="inputField"
            id="input-1"
            type="text"
            rows="3"
            max-rows="6"
            placeholder="Enter Remarks"
            v-model="niremarks"
          >
          </b-form-textarea>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <div
            class="cancelbtntext pointer mr-4"
            @click="$bvModal.hide('not-interested')"
          >
            Cancel
          </div>
          <b-button class="addbtn pr-4 pl-4" @click="makeNotInterested"
            >OK</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      id="onboard"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
      :no-close-on-backdrop="true"
      @hidden="$bvModal.hide('onboard')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
        style="color: #545454"
      >
        Confirmation
      </div>
      <hr />
      <div @click="$bvModal.hide('onboard')" class="xMarkCancel">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <div>
        <div class="modal-text">
          Do you want to move
          <span class="options-text"
            >&ldquo;{{
              `${selectedCandidate.firstName} ${selectedCandidate.lastName} `
            }}&ldquo;</span
          >
          to onboarded?
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <div
            class="cancelbtntext pointer mr-4"
            @click="$bvModal.hide('onboard')"
          >
            Cancel
          </div>
          <b-button class="addbtn pr-4 pl-4" @click="onboardCandidate()"
            >OK</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  sendDocsToCandidate,
  candidateCounts,
  setNotInterested,
  onboardCandidate,
  getOfferInitializePagination,
  ReSendDocsToCandidate,
  getHrNotification,
} from "../../utils/apiFunctions.js";
import { required } from "vuelidate/lib/validators";
import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { getRequiredDocuments } from "../../utils/apiFunctions";
import hrMixin from "../../controllers/HR/hrMixin";

export default {
  name: "Dashboard",
  components: {
    Spinner,
  },
  mixins: [toast, hrMixin],
  data() {
    return {
      //NUMBER
      totalPages: null,
      appointed: 0,
      accepted: 0,
      rejected: 0,
      shortlisted: 0,
      tabIndex: 0,
      count: 50,
      page: 1,
      goToPage: null,
      total: null,
      pageStart: null,
      pageEnd: null,
      timer: null,

      //STRINGS
      expiryDate: "",
      searchname: "",
      searchQuery: "",
      actionList: "",
      sortBy: "updatedAt",
      status: "",
      order: "-1",
      selectedCandidateID: "",
      nicandidateid: "",
      nicandidatemail: "",
      niremarks: "",
      statusValue: "",
      isFresher: "true",
      assignedDocsToggle: "",
      assignedExpDate: "",

      //BOOLEAN
      loaderStatus: false,
      filter: false,
      sortByValue: false,
      reassign: false,

      // OBJECTS
      selectedCandidate: {},
      notificationsObject: {},
      //ARRAYS
      dropDownToggle: [false, false, false],
      allcandidate: [],
      selectedRegForm: [],
      selectedDocs: [],
      selectedDecDocs: [],
      actionCandidates: [],
      documentDetails: [],
      assignedDocs: [],
      assignedDecForms: [],

      //ARRAY OF OBJECTS
      experienced: [
        { text: "Fresher", value: true },
        { text: "Experience", value: false },
      ],
      registrationForms: [
        { name: "Employee Details", value: "employeeDetails" },
        { name: "Educational Details", value: "educationalDetails" },
        { name: "Family Details", value: "familyDetails" },
        { name: "Nominee Details", value: "nomineeDetails" },
        { name: "Work Details", value: "workDetails" },
      ],
      documentsList: [],
    };
  },
  validations() {
    return {
      expiryDate: {
        required,
      },
    };
  },
  watch: {
    isFresher() {
      if (this.isFresher == "false") {
        this.selectedRegForm = [
          "employeeDetails",
          "educationalDetails",
          "familyDetails",
          "workDetails",
        ];
      } else {
        this.selectedRegForm = [
          "employeeDetails",
          "educationalDetails",
          "familyDetails",
        ];
      }
    },
    tabIndex(newValue) {
      let status;
      // Map the tabIndex value to the corresponding status
      switch (newValue) {
        case 0:
          status = "show";
          break;
        case 1:
          status = "action";
          break;
        default:
          status = "show";
          break;
      }
      // Update the route with the new status query parameter
      this.$router.push({
        name: "Dashboard",
        query: {
          status: status,
        },
      });
    },
  },
  filters: {
    formatdate(data) {
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },
  },
  computed: {
    iscontainsNumber() {
      return !/^[1-9]\d*$/.test(this.goToPage);
    },
  },
  async created() {
    this.loaderStatus = true;
    this.setTabIndex();
    await this.getCandidateCount();
    await this.getCandidates();
    this.getRequiredDocuments();
    await this.getHrNotification();
    this.loaderStatus = false;
  },
  methods: {
    // Set tabIndex based on the query variables (check watcher)
    setTabIndex() {
      switch (this.$route.query.status) {
        case "show":
          this.tabIndex = 0;
          break;
        case "action":
          this.tabIndex = 1;
          break;
        default:
          this.tabIndex = 0;
          break;
      }
    },
    async getRequiredDocuments() {
      const res = await getRequiredDocuments();
      if (res.status == 200) {
        this.documentsList = res.data.data;
      }
    },
    // search function
    textSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.page = 1;
        this.getCandidates();
      }, 400);
    },
    // Go to selected Page
    gotopgnum(index) {
      if (index > 0) {
        this.page = Math.min(Math.max(1, index), this.totalPages);
        this.getCandidates();
      }
      this.goToPage = null;
    },
    // ASYNCHRONOUS FUNCTIONS ----- START

    // GET ALL CANDIDATES
    async getCandidates() {
      try {
        let payload = {
          sortBy: this.sortBy,
          order: this.order,
          count: this.count,
          status: this.status,
          actionList: this.actionList,
          searchQuery: this.searchQuery,
          page: this.page - 1,
        };
        const res = await getOfferInitializePagination(payload);
        if (res.status == 200) {
          if (this.actionList) {
            this.actionCandidates = res.data.data.data;
            this.total = res.data.data.total;
            this.pageStart = res.data.data.pageStart;
            this.pageEnd = res.data.data.pageEnd;
            this.totalPages = Math.ceil(
              parseInt(this.total) / parseInt(this.count)
            );
          } else {
            this.allcandidate = res.data.data.data;
            this.total = res.data.data.total;
            this.pageStart = res.data.data.pageStart;
            this.pageEnd = res.data.data.pageEnd;
            this.totalPages = Math.ceil(
              parseInt(this.total) / parseInt(this.count)
            );
          }
        }
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(
          `Failed! getting hr candidates ! status: ${error.status}`
        );
      }
    },

    // GET CANDIDATE COUNT OF EACH STATUS
    async getCandidateCount() {
      try {
        const response = await candidateCounts();
        if (response.status == 200) {
          this.appointed = response.data.data[0].appointedCandidates;
          this.accepted = response.data.data[0].onboardingCandidates;
          this.rejected = response.data.data[0].rejectedCandidates;
          this.shortlisted = response.data.data[0].shortlistedCandidates;
        }
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(`Failed! getCandidateCount ! status: ${error.status}`);
      }
    },

    // ASSIGN DOCS TO CANDIDATE
    async postDocs() {
      const {
        selectedRegForm,
        selectedDocs,
        selectedDecDocs,
        selectedCandidateID,
      } = this;

      if (
        selectedRegForm.length === 0 &&
        selectedDocs.length === 0 &&
        selectedDecDocs.length === 0
      ) {
        this.errorModal("At least one document must be selected");
        return;
      }

      this.$v.expiryDate.$touch();

      if (this.$v.expiryDate.$invalid) {
        return;
      }

      this.loaderStatus = true;

      try {
        const payload = {
          expiryDate: this.expiryDate,
          candidateIDs: [selectedCandidateID],
          document: {
            documents: selectedDocs,
            decForm: selectedDecDocs,
          },
        };

        for (const regForm of this.registrationForms) {
          payload.document[regForm.value] = selectedRegForm.includes(
            regForm.value
          );
        }

        const response = await sendDocsToCandidate(payload);

        if (response.status === 200) {
          await this.getCandidates();
          this.closeAssignDocs();
          this.successModal("Documents sent successfully");
        } else {
          this.errorModal(response.data.data.status);
        }

        this.loaderStatus = false;
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(`Failed! postDocs! status: ${error.status}`);
      }
    },

    // REASSIGN DOCS TO CANDIDATE
    async putDocs() {
      const {
        selectedRegForm,
        selectedDocs,
        selectedDecDocs,
        selectedCandidateID,
      } = this;

      if (
        selectedRegForm.length === 0 &&
        selectedDocs.length === 0 &&
        selectedDecDocs.length === 0
      ) {
        this.errorModal("At least one document must be selected");
        return;
      }

      this.$v.expiryDate.$touch();

      if (this.$v.expiryDate.$invalid) {
        return;
      }

      this.loaderStatus = true;

      try {
        const payload = {
          expiryDate: this.expiryDate,
          candidateID: selectedCandidateID,
          document: {
            documents: selectedDocs,
            decForm: selectedDecDocs,
          },
        };

        for (const regForm of this.registrationForms) {
          payload.document[regForm.value] = selectedRegForm.includes(
            regForm.value
          );
        }

        const response = await ReSendDocsToCandidate(payload);

        if (response.status === 200) {
          await this.getCandidates();
          this.closeAssignDocs();
          this.successModal("Reassigned documents successfully");
        } else {
          this.errorModal(response.data.data.status);
        }

        this.loaderStatus = false;
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // MAKE CANDIDATE AS NOT INTERESTED
    async makeNotInterested() {
      try {
        let payload = {
          candidateID: this.selectedCandidate.RecCandidateID,
          remarks: this.niremarks,
        };
        const response = await setNotInterested(payload);
        if (response.status == 200) {
          this.getCandidates();
          this.$bvModal.hide("not-interested");
          this.successModal("Candidate moved to not interested");
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
        throw new Error(`Failed! makeNotInterested ! status: ${error.status}`);
      }
    },
    // ASYNCHRONOUS FUNCTIONS ----- END

    // OPEN ASSIGN DOCS MODAL
    openDocsModel(data) {
      this.selectedCandidateID = data.RecCandidateID;
      if (data.experience != 0) {
        this.isFresher = "false";
      } else {
        this.isFresher = "true";
      }

      this.selectedRegForm = [
        "employeeDetails",
        "educationalDetails",
        "familyDetails",
      ];
      this.$bvModal.show("assign-docs");
    },

    // CLOSE ASSIGN DOCS MODAL
    closeAssignDocs() {
      this.selectedDocs = [];
      this.selectedRegForm = [];
      this.selectedDecDocs = [];
      this.isFresher = "true";
      this.dropDownToggle = [false, false, false];
      this.expiryDate = "";
      this.$v.$reset();
      this.$bvModal.hide("assign-docs");
    },

    closeReassignExp() {
      this.dropDownToggle = [false, false, false];
      this.assignedDecForms = [];
      this.assignedExpDate = "";
      this.assignedDocs = [];
      this.$bvModal.hide("change-date");
    },

    openNotInterested(candidate) {
      this.selectedCandidate = candidate;
      this.$bvModal.show("not-interested");
    },

    // OPEN EXPIRY DATESELECTOR
    gotoexpdate() {
      this.$refs.dob.$el.children[0].click();
    },
    gotoexpdates() {
      this.$refs.exp.$el.children[0].click();
    },
    // GET HR NOTIFICATIONS
    async getHrNotification() {
      try {
        const { data } = await getHrNotification();
        this.notificationsObject = data.data;
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    // HELPER FUNTIONS ---- END

    // FUNCTIONS FOR NAVIGATING THROUGH ROUTER ---- START
    goToOfferLetter(candidateID) {
      this.$router.push({
        name: "OfferLetter",
        params: { candidateID: candidateID },
        query: {
          redirect: "SelectedCandidates",
        },
      });
    },
    goToAppointLetter(candidateID) {
      this.$router.push({
        name: "AppointmentLetter",
        params: {
          candidateID: candidateID,
        },
        query: {
          redirect: "Dashboard",
        },
      });
    },
    goToCandidateDetails(data) {
      this.$router.push({
        name: "CandidateDetails",
        params: {
          candidateID: data,
        },
        query: {
          redirect: this.$route.name,
          status: this.$route.query.status,
        },
      });
    },
    goToReviewDocs(candidateID) {
      this.$router.push({
        name: "ViewOnboardingCandidate",
        params: {
          candidateID: candidateID,
        },
        query: {
          redirect: "Dashboard",
        },
      });
    },
    goToResend(i) {
      this.$store.commit("hrPortalReferenceVUEX/saveSelectCandidate", {});

      this.$router.push({
        name: "EditOfferLetter",
        params: {
          candidateID: i,
        },
        query: {
          redirect: "Dashboard",
        },
      });
    },
    goToGenerateOffer(id) {
      this.$store.commit("hrPortalReferenceVUEX/saveSelectCandidate", {});
      this.$router.push({
        name: "EditOfferLetter",
        params: {
          candidateID: id,
        },
        query: {
          redirect: "Dashboard",
        },
      });
    },
    async onboardCandidate() {
      try {
        let payload = {
          candidateID: this.selectedCandidate.candidateID,
        };
        const res = await onboardCandidate(payload);
        if (res.status == 200) {
          this.successModal(
            `${this.selectedCandidate.email} onboarded successfully`
          );
        }
      } catch (error) {
        throw new Error(`Failed! onboardCandidate ! status: ${error.status}`);
      }
    },
    gotoonboardingpage() {
      this.$router.push({
        name: "OnboardingCandidates",
      });
    },
    gotorejectedPage() {
      this.$router.push({
        name: "RejectedCandidates",
      });
    },
    gotoslectedcandpage() {
      this.$router.push({
        name: "SelectedCandidates",
      });
    },
    goToOfferPage(i) {
      this.$store.commit("hrPortalReferenceVUEX/saveSelectCandidate", i);
      this.$router.push({
        name: "ViewCandidateOfferDetails",
      });
    },
    goToAppoint() {
      this.$router.push({
        name: "SendAppointment",
      });
    },
    // FUNCTIONS FOR NAVIGATING THROUGH ROUTER ---- END
  },
};
</script>

<style>
.dec-form-list {
  max-height: 160px;
  overflow: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
.modal-text {
  font-weight: 400;
  font-size: 14px;
  color: #8a8b8c;
}

.hr-nibox {
  padding: 10px;
  background-color: #f4f4f4;
  border-radius: 5px;
  font-weight: 400;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #545454;
}

.viewmore-parent {
  position: relative;
}

.validationicon-exp {
  position: absolute;
  top: 5px;
  right: 28px;
  background: var(--bg-white);
}

.selected-table-cards:hover {
  background: #e7e8f5;
}

.hr-dashboard-table-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  height: calc(100vh - 75px);
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
}

.name-cel {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
}

.vertical-bar {
  width: 5px;
  background: #f55a35;
  border-radius: 3px;
  height: 100%;
}

.confirm-btn {
  height: 34px;
  width: 140px;
}

.calender-class {
  position: absolute;
  top: 7px;
  right: 10px;
  z-index: 1;
}

.datepicker-cust .btn {
  padding: 0.375rem 0;
}

.topDiv > .joiningstyle {
  border: 0.7px solid rgba(114, 115, 142, 0.7);
  box-shadow: 0px 0px 15px rgb(0 0 0 / 10%);
}
.reg-form-list {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  transition: visibility 0s, opacity 0.5s;
  overflow: auto;
}

.heading-doc {
  font-weight: 600;
  font-size: 14px;
  color: #6d6d6d;
}

.reg-form {
  height: 47px;
  width: 100%;
  background: #fdfdfd;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
}

.options-text {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}

.doc-model-sub-head {
  font-weight: 700;
  font-size: 14px;
  color: #545454;
}

.doc-sub {
  height: 700px;
  overflow: auto;
  padding-left: 5px;
  padding-right: 5px;
}

.doc-modal {
  min-height: auto;
  max-height: calc(100vh - 250px);
  overflow: auto;
}

.qb-dropdown-option-box:nth-child(even) {
  background: #fdfdfd;
  padding: 10px 30px;
}

.qb-dropdown-option-box:nth-child(odd) {
  background: #f4f4f4;
  padding: 10px 30px;
}

.send-btn {
  font-size: 13px;
  width: 200px;
  font-weight: 400;
  color: #fafafa;
  background: #72738e;
  border-radius: 5px;
}

.noti-icon-bg {
  width: 32px;
  height: 32px;
  text-align: center;
  border-radius: 15px;
  background: rgba(76, 159, 255, 0.1);
}

.hr-notification-innercards {
  width: 50%;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 10px;
}

.b-form-btn-label-control.form-control > .btn > svg {
  display: none !important;
}
.hr-notification-text {
  font-weight: 600;
  font-size: 14px;
  color: #72738e;
}

.hr-notification-subtext {
  font-weight: 400;
  font-size: 13px;
  color: #72738e;
}

.hr-dash-cand-maintext {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  color: #ffffff;
}

.hr-dash-cand-subtext {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
}

.onbaord-hr-dash-cand-container {
  background: linear-gradient(79.6deg, #ffb750 -0.01%, #ffc97d 101.3%);
  box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  height: 125px;
  width: 50%;
}

.shortlisted-hr-dash-cand-container {
  height: 125px;
  width: 50%;
  background: linear-gradient(79.6deg, #429aff -0.01%, #58a5ff 101.3%);
  box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}

.rejected-hr-dash-cand-container {
  height: 125px;
  width: 50%;
  background: linear-gradient(79.6deg, #ff5672 -0.01%, #ff8196 101.3%);
  box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}

.send-hr-dash-cand-container {
  height: 125px;
  width: 50%;
  background: linear-gradient(79.6deg, #31d8b7 -0.01%, #56dfc2 101.3%);
  box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}

.hr-dash-notifn-container {
  width: 50%;
  height: 258px;
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(196, 196, 196, 0.5);
  border-radius: 10px;
}

.dashboard-table-cards:hover {
  background: #e7e8f5;
}

.hr-dashboard .tabbed ul li a.active:before {
  background: #72738e !important;
}

.hr-dashboard .tabbed ul li a:before {
  display: block;
  content: " ";
  position: absolute;
  top: 1px;
  height: 105%;
  width: 44px;
  margin-top: -2px;
  border-top: none;
  transition: all 250ms ease;
  background: #ececec;
}

.text-break {
  display: block;
  width: 100%;
  word-wrap: break-word;
}
</style>

<style scoped>
.topDiv > .inputField {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  background: #fdfdfd;
  border: 0.7px solid rgba(114, 115, 142, 0.7);
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 3px !important;
  z-index: 0 !important;
  padding-left: 6px;
}

.custom-control {
  z-index: unset !important;
}
</style>
